import { useLocation, useNavigate } from 'react-router-dom';
import { House, FilmStrip, ChatCircleDots, UsersThree, UserCircle } from '@phosphor-icons/react';
import { dashboardRoute, hapticTap } from '../../lib/native';

const NativeTabBar = ({ user }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const mePath = dashboardRoute(user);

  const tabs = [
    { id: 'home', label: 'Home', path: '/', Icon: House, match: (p) => p === '/' || p === '/classic' || p.startsWith('/themes') },
    { id: 'browse', label: 'Browse', path: '/marketplace', Icon: FilmStrip, match: (p) => p.startsWith('/marketplace') || p.startsWith('/movie/') },
    { id: 'community', label: 'Community', path: '/community', Icon: ChatCircleDots, match: (p) => p.startsWith('/community') },
    { id: 'fraternity', label: 'Crew', path: '/fraternity', Icon: UsersThree, match: (p) => p.startsWith('/fraternity') },
    { id: 'me', label: user ? 'Me' : 'Sign in', path: mePath, Icon: UserCircle, match: (p) => p.startsWith('/fan-dashboard') || p.startsWith('/investor-dashboard') || p.startsWith('/producer-dashboard') || p.startsWith('/admin-dashboard') || p.startsWith('/login') || p.startsWith('/register') || p.startsWith('/invite') || p.startsWith('/notifications') || p.startsWith('/legal') },
  ];

  return (
    <nav className="native-tab-bar" aria-label="Main" data-testid="native-tab-bar">
      {tabs.map(({ id, label, path, Icon, match }) => {
        const active = match(pathname);
        return (
          <button
            key={id}
            type="button"
            data-testid={`native-tab-${id}`}
            aria-current={active ? 'page' : undefined}
            className={`native-tab-item${active ? ' is-active' : ''}`}
            onClick={() => {
              hapticTap();
              if (active) window.scrollTo({ top: 0, behavior: 'smooth' });
              else navigate(path);
            }}
          >
            <span className="native-tab-pill" aria-hidden="true">
              <Icon size={22} weight={active ? 'fill' : 'regular'} />
            </span>
            <span className="native-tab-label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default NativeTabBar;
